<div class="modal-header">
  <h3 class="modal-title">{{ "data.validate_receptions" | translate }}</h3>
  <button type="button" aria-label="Close" (click)="closeModal()">
    <i class="fa fa-close"></i>
  </button>
</div>
<div class="modal-body">
  <div class="main-card mb-3 card">
    <div class="card-body">
      <div class="row mb-5">
        <div class="col-md-12">
          <form [formGroup]="form" (ngSubmit)="validate()">
            <div class="row form-group justify-content-center">
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="collectorPickUp" class="">
                    {{ "data.enter_collector" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="selectedTransportor"
                    name="selectedTransportor"
                    id="selectedTransportor"
                  >
                    <option [ngValue]="undefined">
                      {{ "data.select_collect" | translate }}
                    </option>
                    <option
                      [value]="collector._id"
                      *ngFor="let collector of collectorList"
                    >
                      {{ collector.nameSociety }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('selectedTransportor').touched &&
                      form.get('selectedTransportor').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="collectorPickUp" class="">
                    {{ "data.Transport_type" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="transportorType"
                    name="transportorType"
                    id="transportorType"
                  >
                    <option [ngValue]="undefined">
                      {{ "data.select_collect" | translate }}
                    </option>
                    <option
                      [value]="item"
                      *ngFor="let item of transportorTypes"
                    >
                      {{ item }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('transportorType').touched &&
                      form.get('transportorType').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group justify-content-center">
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="remorqueId" class="">
                    {{ "data.trailer_number" | translate }} :
                  </legend>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="remorqueId"
                    name="remorqueId"
                    id="remorqueId"
                    placeholder="Ex: Remorque ID"
                  />
                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('remorqueId').touched &&
                      form.get('remorqueId').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="plateform" class="">
                    {{ "data.plateform" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="plateform"
                    name="plateform"
                    id="plateform"
                  >
                    <option [ngValue]="undefined">Select a plateform</option>
                    <option
                      [value]="plateform"
                      *ngFor="let plateform of plateformList"
                    >
                      {{ plateform }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('plateform').touched &&
                      form.get('plateform').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="row form-group justify-content-center">
                            <div class="col-12 col-md-8">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <legend class="mb-0">Offres : </legend>
                                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="addOffer()">
                                        + Ajouter
                                    </button>
                                </div>

                                <div formArrayName="offers">
                                    <div class="form-row align-items-end mb-2 p-2 border rounded"
                                        *ngFor="let offerGroup of offersFA.controls; let i = index" [formGroupName]="i">

                                        <div class="form-group col-md-5 mb-auto">
                                            <legend class="">
                                                Label :
                                            </legend>
                                            <input type="text" class="form-control" formControlName="label"
                                                name="label-{{i}}" id="label-{{i}}" placeholder="Ex: Livraison express">
                                            <div class="text-danger mt-1"
                                                *ngIf="offerGroup.get('label').touched && offerGroup.get('label').invalid">
                                                Le label est requis.
                                            </div>
                                        </div>

                                        <div class="form-group col-md-5 mb-auto">
                                            <legend class="">Value</legend>
                                            <input type="number" class="form-control" formControlName="value" min="0"
                                                name="value-{{i}}" id="value-{{i}}" step="0.01" placeholder="0.00">
                                            <div class="text-danger mt-1"
                                                *ngIf="offerGroup.get('value').touched && offerGroup.get('value').invalid">
                                                La valeur est requise et doit être ≥ 0.
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2 text-right mt-auto mb-auto">
                                            <button type="button" class="btn btn-outline-danger"
                                                (click)="removeOffer(i)">Supprimer</button>
                                        </div>
                                    </div>

                                    <div class="text-muted" *ngIf="offersFA.length === 0">
                                        Aucune offre. Cliquez sur “Ajouter une offre”.
                                    </div>
                                </div>
                            </div>
                        </div> -->

            <div class="row form-group justify-content-center">
              <!-- <div class="col-12 col-md-5">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="h4">Total</div>
                                    <div class="h3 font-weight-bold text-danger">
                                        {{ totalPrice | number:'1.3-3' }} EUR
                                    </div>
                                </div>
                            </div> -->

              <div class="col-12 text-center mt-3">
                <button type="submit" class="btn btn-success btn-lg">
                  {{ "data.save" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table
              class="align-middle mb-0 table table-borderless table-striped table-hover"
            >
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>{{ "data.provider" | translate }}</th>
                  <th>{{ "data.reference" | translate }}</th>
                  <th>{{ "data.creation_date" | translate }}</th>
                  <th class="text-center">
                    {{ "data.products" | translate }}<br />
                    {{ "data.quantity_product_name" | translate }}
                  </th>
                  <th class="text-center">
                    {{ "data.volume" | translate }}<br />(m³)
                  </th>
                  <th class="text-center">
                    {{ "data.total_weight" | translate }}<br />(Kg)
                  </th>
                  <th class="text-center">
                    {{ "data.total" | translate }}<br />(€)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let cmd of selectedCmds; let index = index">
                  <td class="text-center text-muted">#{{ index + 1 }}</td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="widget-content-left">
                            <ngx-avatar
                              class="rounded-circle"
                              name="{{ cmd?.client_cmd?.prenom_client }}
                                                {{
                                cmd?.client_cmd?.nom_client
                              }}"
                            >
                            </ngx-avatar>
                          </div>
                        </div>
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">
                            {{ cmd?.client_cmd?.providerName }}
                          </div>
                          <div class="widget-subheading opacity-7">
                            {{ cmd?.client_cmd?.shippingAdress?.label_target }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{{ cmd?.ref_facture_cmd }}</td>
                  <td>
                    {{ cmd?.date_creation_cmd | date : "d MMM y" }}<br />
                    <b>{{ cmd?.date_creation_cmd | date : "HH:mm" }}</b>
                  </td>
                  <td>
                    <ul
                      class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                      *ngIf="cmd?.totalBoxes > 0"
                    >
                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left mr-3 widget-pallet">
                              <img
                                width="100%"
                                src="https://assets.marketbey.tn/WTM/products/box.png"
                                alt=""
                              />
                            </div>
                            <div class="widget-content-right">
                              <div class="font-size-lg text-muted">
                                <span>
                                  {{
                                    cmd?.totalBoxes -
                                      (cmd?.etat_cmd == "partially_received" &&
                                      cmd?.totalBoxesReceived
                                        ? cmd?.totalBoxesReceived
                                        : 0)
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul
                      class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                      *ngIf="cmd?.totalPallets > 0"
                    >
                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left mr-3 widget-pallet">
                              <img
                                width="100%"
                                src="https://assets.marketbey.tn/WTM/products/pallet.png"
                                alt=""
                              />
                            </div>
                            <div class="widget-content-right">
                              <div class="font-size-lg text-muted">
                                <span>
                                  {{
                                    cmd?.totalPallets -
                                      (cmd?.etat_cmd == "partially_received" &&
                                      cmd?.totalPalletsReceived
                                        ? cmd?.totalPalletsReceived
                                        : 0)
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </td>
                  <td class="text-center">
                    <!-- {{
                      cmd?.totalPalletVolume -
                        (cmd?.etat_cmd == "partially_received" &&
                        cmd?.totalPalletVolumeReceived
                          ? cmd?.totalPalletVolumeReceived
                          : 0) | number : "0.1"
                    }} -->
                    {{ cmd?.totalVolume | number : "0.1" }}
                  </td>
                  <td class="text-center">
                    <div *ngIf="cmd?.etat_cmd !== 'partially_received'">
                      {{ cmd?.totalPoids | number : "0.1" }}
                    </div>
                  </td>
                  <td class="text-center">
                    {{ cmd?.total_ca_cmd | number : "0.3" }} EUR
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
    {{ "data.close" | translate }}
  </button>
</div>
